import { persistStorage } from '@shared/lib/persist-storage'

import { ROUTER_STORAGE_KEY } from './config'
import { RouterStorageType } from './types'

export interface IRouterRepository {
  getState(): RouterStorageType
  setState(state: RouterStorageType): void
}

export class RouterRepository implements IRouterRepository {
  getState(): RouterStorageType {
    return persistStorage.getItemSafe<RouterStorageType>(ROUTER_STORAGE_KEY, {
      current: null,
      prev: null
    })
  }

  setState(state: RouterStorageType): void {
    return persistStorage.setItemSafe(ROUTER_STORAGE_KEY, state)
  }
}

export const routerRepository = new RouterRepository()
